import React, { useState, useEffect, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import axiosPrivate from "../api/axios";
import { InputNumber } from "primereact/inputnumber"; // al inicio si no lo has importado
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { Fieldset } from "primereact/fieldset";
const opcionesValidacion = [
  { label: "Periodo de nómina", value: "periodo" },
  { label: "Mes completo", value: "mes" },
];

const modulos = ["faltas", "bonos", "bajas", "cambios Salario"];

export default function ConfiguracionSistema({ Auth }) {
  const [config, setConfig] = useState({});
  const toast = useRef(null);

  useEffect(() => {
    if (!Auth?.roles.includes(1984)) return;

    const fetchConfig = async () => {
      try {
        const response = await axiosPrivate.get("/NOM/configuracion/sistema");
        setConfig(response.data || {});
      } catch (error) {
        toast.current.show({
          severity: "error",
          summary: "Error al cargar configuración",
          detail: error.message,
        });
      }
    };

    fetchConfig();
  }, []);

  const handleCambioValidacion = (modulo, value) => {
    setConfig((prev) => ({
      ...prev,
      [modulo]: {
        ...prev[modulo],
        validacionFechas: value,
      },
    }));
  };

  const handleCambioRango = (modulo, campo, fecha) => {
    setConfig((prev) => ({
      ...prev,
      [modulo]: {
        ...prev[modulo],
        rango: {
          ...prev[modulo]?.rango,
          [campo]: fecha,
        },
      },
    }));
  };

  const guardar = async () => {
    try {
      await axiosPrivate.put("/NOM/configuracion/sistema", config);
      toast.current.show({
        severity: "success",
        summary: "Configuración guardada",
        detail: "Se aplicaron los cambios correctamente",
      });
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error al guardar",
        detail: error.message,
      });
    }
  };

  return (
  <div className="p-4">
    <Toast ref={toast} />
    <h2 className="text-2xl mb-3">⚙️ Configuración del Sistema</h2>
    <p className="text-gray-600 mb-4">
      Define las restricciones de captura de información para cada módulo.
    </p>

    <div className="grid gap-4">
      {modulos.map((modulo) => (
        <Card key={modulo} title={modulo.toUpperCase()} className="shadow-2">
          <div className="mb-3">
            <label className="font-medium block mb-2">
              Validación de fechas permitidas
            </label>
            <Dropdown
              value={config[modulo]?.validacionFechas}
              options={opcionesValidacion}
              onChange={(e) => handleCambioValidacion(modulo, e.value)}
              placeholder="Seleccione validación"
              className="w-full md:w-20rem"
            />
          </div>

          {config[modulo]?.validacionFechas === "personalizado" && (
            <div className="flex flex-column md:flex-row gap-3 mb-4">
              <Calendar
                value={
                  config[modulo]?.rango?.inicio
                    ? new Date(config[modulo].rango.inicio)
                    : null
                }
                onChange={(e) => handleCambioRango(modulo, "inicio", e.value)}
                placeholder="Fecha inicio"
                showIcon
              />
              <Calendar
                value={
                  config[modulo]?.rango?.fin
                    ? new Date(config[modulo].rango.fin)
                    : null
                }
                onChange={(e) => handleCambioRango(modulo, "fin", e.value)}
                placeholder="Fecha fin"
                showIcon
              />
            </div>
          )}

          <Divider />

          <Fieldset legend="Restricción de días para capturar movimientos">
            <div className="mb-3">
              <Dropdown
                value={config[modulo]?.capturaDias?.tipo}
                options={[
                  { label: "Todos los días del periodo", value: "todos" },
                  { label: "Primeros N días del periodo", value: "primeros" },
                //   { label: "Últimos N días del periodo", value: "ultimos" },
                //   { label: "Rango personalizado", value: "personalizado" },
                ]}
                onChange={(e) =>
                  setConfig((prev) => ({
                    ...prev,
                    [modulo]: {
                      ...prev[modulo],
                      capturaDias: {
                        tipo: e.value,
                      },
                    },
                  }))
                }
                placeholder="Seleccione restricción"
                className="w-full md:w-20rem"
              />
            </div>

            {["primeros", "ultimos"].includes(
              config[modulo]?.capturaDias?.tipo
            ) && (
              <div className="mt-2">
                <label>Cantidad de días permitidos</label>
                <InputNumber
                  value={config[modulo]?.capturaDias?.cantidad || 0}
                  onValueChange={(e) =>
                    setConfig((prev) => ({
                      ...prev,
                      [modulo]: {
                        ...prev[modulo],
                        capturaDias: {
                          ...prev[modulo].capturaDias,
                          cantidad: e.value,
                        },
                      },
                    }))
                  }
                  min={0}
                  max={31}
                //   showButtons
                />
              </div>
            )}

            {config[modulo]?.capturaDias?.tipo === "personalizado" && (
              <div className="flex flex-column md:flex-row gap-3 mt-2">
                <Calendar
                  value={
                    config[modulo]?.capturaDias?.rango?.inicio
                      ? new Date(config[modulo].capturaDias.rango.inicio)
                      : null
                  }
                  onChange={(e) =>
                    setConfig((prev) => ({
                      ...prev,
                      [modulo]: {
                        ...prev[modulo],
                        capturaDias: {
                          ...prev[modulo].capturaDias,
                          rango: {
                            ...prev[modulo]?.capturaDias?.rango,
                            inicio: e.value,
                          },
                        },
                      },
                    }))
                  }
                  placeholder="Fecha inicio"
                  showIcon
                />
                <Calendar
                  value={
                    config[modulo]?.capturaDias?.rango?.fin
                      ? new Date(config[modulo].capturaDias.rango.fin)
                      : null
                  }
                  onChange={(e) =>
                    setConfig((prev) => ({
                      ...prev,
                      [modulo]: {
                        ...prev[modulo],
                        capturaDias: {
                          ...prev[modulo].capturaDias,
                          rango: {
                            ...prev[modulo]?.capturaDias?.rango,
                            fin: e.value,
                          },
                        },
                      },
                    }))
                  }
                  placeholder="Fecha fin"
                  showIcon
                />
              </div>
            )}
          </Fieldset>
        </Card>
      ))}
    </div>

    <div className="mt-4">
      <Button
        label="Guardar configuración"
        icon="pi pi-save"
        onClick={guardar}
        className="p-button-success"
      />
    </div>
  </div>
);
;
}
